import { Button, Divider, Form, Input, Drawer, Space, Tooltip } from "antd";
import React, { useRef } from "react";
import ItemsService from "../../Services/ItemsService";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/Routing/PageRoute";
import { CloseOutlined } from "@ant-design/icons";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
import { useHotkey } from "../../Context/HotKeyContext";
// import { useMutation, useQueryClient } from "react-query";

const ItemLocationModel: React.FC<{
  open: boolean;
  onCancel: any;
  setTrigger: any;
  data?: any;
  setAddNewLocation?: any;
}> = (props) => {
  const { showKeys } = useHotkey();
  const autoCompleteRef = useRef<any>(null);
  const [form] = Form.useForm();
  // const queryClient = useQueryClient();
  const { currentClient } = useClient();
  const { openNotification } = React.useContext(notificationContext);
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);

  // Post Api
  const postItem = () => {
    form.validateFields().then(async (value: any) => {
      setSaveButtonLoading(true);
      let data = {
        ...value,
      };

      await ItemsService.postItemLocation(
        data,
        currentClient?.id,
        props.data?.id
      )
        .then((res: any) => {
          if (res?.status) {
            // queryClient.invalidateQueries({
            //   queryKey: ["locations"],
            // });

            props?.setAddNewLocation && props?.setAddNewLocation(res?.result);
            openNotification(
              "success",
              `Item Location ${
                props.data?.id ? "updated successfully." : "added successfully."
              }`
            );
            props.onCancel();
            setSaveButtonLoading(false);
            props.setTrigger((x: boolean) => !x);
          } else {
            openNotification("error", res?.message);
            props.onCancel();
            setSaveButtonLoading(false);
            props.setTrigger((x: boolean) => !x);
          }

          // console.log(res);
        })
        .catch((ex: any) => {
          setSaveButtonLoading(false);
          openNotification("error", ex);
          console.error(ex);
        });
    });
  };

  // Get Api
  React.useEffect(() => {
    if (props?.data?.id) {
      form.setFieldsValue({ ...props?.data });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.data?.id]);

  // --------- InitialValues in Add Item Location Model ---------
  const initialValues = {};
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, []); // Ensures autofocus after initial render

  EntryLevelKeys({
    save: () => postItem(),
    cancel: () => props.onCancel(false),
  });

  return (
    <div>
      <Drawer
        open={props.open}
        title={props?.data?.id ? "Update Item Location" : "Add Item Location"}
        width={"500px"}
        onClose={() => props.onCancel()}
        closable={false}
        extra={
          <Space>
            <CloseOutlined onClick={() => props.onCancel()} />
          </Space>
        }
        footer={
          <div style={{ textAlign: "right" }}>
            <Tooltip
              title={<p>ALT+C</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                onClick={() => {
                  form.resetFields();
                  props.onCancel();
                }}
              >
                Cancel
              </Button>
            </Tooltip>
            <Tooltip
              title={<p>ALT+S</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                className="modelSaveButtonMargin"
                type="primary"
                onClick={() => postItem()}
                loading={saveButtonLoading}
              >
                {!props?.data?.id ? "Save" : "Update"}
              </Button>
            </Tooltip>
          </div>
        }
      >
        <Form
          form={form}
          name="itemLocation"
          autoCapitalize="false"
          requiredMark={true}
          initialValues={initialValues}
          colon={false}
          labelAlign="left"
          // labelCol={{ xs: 9, sm: 8 }}
          // wrapperCol={{ xs: 16, sm: 16 }}
          labelWrap={true}
          layout="vertical"
        >
          <Form.Item
            label="Item Location Name"
            name="itemLocationName"
            rules={[
              { required: true, message: "Item location's name is required" },
            ]}
            // className="input-item"
          >
            <Input
              placeholder="Item location's name"
              // onInput={(e: any) => {
              //   e.target.value = e.target.value.toUpperCase();
              // }}
              ref={autoCompleteRef}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default ItemLocationModel;
